import { render, staticRenderFns } from "./LicenseDetailDialog.vue?vue&type=template&id=6fbf8ffc&scoped=true&"
import script from "./LicenseDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseDetailDialog.vue?vue&type=style&index=0&id=6fbf8ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf8ffc",
  null
  
)

export default component.exports